import * as React from 'react';

export default function Restaurant({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 20 20'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 5.0013V10.0013C13.3333 10.918 14.0833 11.668 15 11.668H15.8333V17.5013C15.8333 17.9596 16.2083 18.3346 16.6667 18.3346C17.125 18.3346 17.5 17.9596 17.5 17.5013V2.60964C17.5 2.06797 16.9917 1.66797 16.4667 1.79297C14.6667 2.23464 13.3333 3.75964 13.3333 5.0013ZM9.16667 7.5013H7.5V2.5013C7.5 2.04297 7.125 1.66797 6.66667 1.66797C6.20833 1.66797 5.83333 2.04297 5.83333 2.5013V7.5013H4.16667V2.5013C4.16667 2.04297 3.79167 1.66797 3.33333 1.66797C2.875 1.66797 2.5 2.04297 2.5 2.5013V7.5013C2.5 9.34297 3.99167 10.8346 5.83333 10.8346V17.5013C5.83333 17.9596 6.20833 18.3346 6.66667 18.3346C7.125 18.3346 7.5 17.9596 7.5 17.5013V10.8346C9.34167 10.8346 10.8333 9.34297 10.8333 7.5013V2.5013C10.8333 2.04297 10.4583 1.66797 10 1.66797C9.54167 1.66797 9.16667 2.04297 9.16667 2.5013V7.5013Z"
        fill="currentColor"
      />
    </svg>
  );
}
